module.exports = __webpack_public_path__ + "static/img/layer9.e3d6a96.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/layer9.png
// module id = 9cg+
// module chunks = 0